module.exports = __webpack_public_path__ + "img/img-12.e4ab77f4.webp";